import React from 'react';
import { useHistory } from 'react-router-dom';
import App from '@app';
import { Body, PageHeader } from '@components';
import TableConfiguracoes from './TableConfiguracoes';

export default function Configuracoes() {
  const history = useHistory();

  return (
    <App>
      <Body>
        <PageHeader title="Conectores" onBack={() => history.goBack()}>
          <TableConfiguracoes />
        </PageHeader>
      </Body>
    </App>
  );
}
